"use client";

import {
  Castle,
  Crown,
  Footprints,
  Gem,
  Landmark,
  MapPinned,
  Milestone,
  Mountain,
  MountainSnow,
  Route,
  Sunrise,
  TentTree,
} from "lucide-react";
import { cn } from "@/lib/utils";

function normalizeRouteName(name: string) {
  return name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

function RouteIconGlyph({ name, className }: { name: string; className?: string }) {
  const normalized = normalizeRouteName(name);

  if (normalized.includes("intipunku") || normalized.includes("sun gate")) return <Sunrise className={className} aria-hidden="true" />;
  if (normalized.includes("inka bridge") || normalized.includes("inca bridge")) return <Milestone className={className} aria-hidden="true" />;
  if (normalized.includes("great cavern") || normalized.includes("gran caverna") || normalized.includes("caverna")) {
    return <Gem className={className} aria-hidden="true" />;
  }
  if (normalized.includes("royalty") || normalized.includes("realeza")) return <Crown className={className} aria-hidden="true" />;
  if (normalized.includes("huayna") || normalized.includes("wayna")) return <MountainSnow className={className} aria-hidden="true" />;
  if (normalized.includes("machupicchu mountain") || normalized.includes("machu picchu mountain")) {
    return <Mountain className={className} aria-hidden="true" />;
  }
  if (normalized.includes("huchuy")) return <Footprints className={className} aria-hidden="true" />;
  if (normalized.includes("upper terrace") || normalized.includes("terraza superior")) return <Landmark className={className} aria-hidden="true" />;
  if (normalized.includes("lower terrace") || normalized.includes("terraza inferior")) return <Castle className={className} aria-hidden="true" />;
  if (normalized.includes("classic") || normalized.includes("clasica") || normalized.includes("classica")) return <Route className={className} aria-hidden="true" />;
  if (normalized.includes("designed")) return <TentTree className={className} aria-hidden="true" />;

  return <MapPinned className={className} aria-hidden="true" />;
}

export function RouteIcon({
  name,
  className,
  iconClassName,
}: {
  name: string;
  className?: string;
  iconClassName?: string;
}) {
  return (
    <span className={cn("flex size-8 shrink-0 items-center justify-center rounded-full bg-muted text-emerald", className)}>
      <RouteIconGlyph name={name} className={cn("size-4", iconClassName)} />
    </span>
  );
}
